import axios from 'axios'
// import Cookies from 'js-cookie'
import router from "../router"

// import $ from 'jquery'


import { Loading, Message, Notification } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
/***
 * @api文档地址
 * https://documenter.getpostman.com/view/9459507/TzzBoauW#efeff34e-9057-49be-8555-91eae2740bff
 * http://192.168.0.107:8083
 *
 */
const http = axios.create({
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    // baseURL: process.env.API_ROOT,
    baseURL: index_root,
    timeout: 20000
})


// let loading;
// let loadingNum = 0;
// function startLoading() {
//     if (loadingNum == 0) {
//         loading = Loading.service({
//             lock: true,
//             text: 'loading...',
//             background: 'rgba(0,0,0,0.8)',
//         })
//     }
//     //请求数量加1
//     loadingNum++;
// }
// function endLoading() {
//     //请求数量减1
//     loadingNum--
//     if (loadingNum <= 0) {
//         loading.close();
//     }
// }


let language
http.interceptors.request.use(config => {
    // startLoading();
    if (config.method == "post") {

    }

    // config.headers.authorization = "Bearer" + " " + localStorage.access_token;
    config.headers.authorization = "Bearer" + " " +  localStorage.getItem('access_token')

    return config

}, err => {

    return Promise.reject(err);

})



http.interceptors.response.use(res => {
    // endLoading()
    // console.log(JSON.stringify(res))

    if (res.status == 200) {
        let status = res.data.meta.status || res.meta.status || res.status;
        // console.log(status);
        switch (status) {
            case 10403:
                Message.warning(res.data.data);
                break;
            case 20002:
                if(language === "en"){
                    Message.warning("Please login first");
                }else{
                    Message.warning("请先登录");
                }
                router.push("/login");
                break;
            case 20003:
                if(language === "en"){
                    Message.warning("Invalid CAPTCHA");
                }else{
                    Message.error("无效的验证码");
                }

                break;
            case 20005:
                if(language === "en"){
                    Message.warning("Failed to obtain user information");
                }else{
                    Message.error("获取用户信息失败");
                }
                router.push("/login");
                break;
            case 20006:
                if(language === "en"){
                    Message.warning("Login expired");
                }else{
                    Message.error("登录已过期");
                }

                router.push("/login");
                break;
            case 20007:
                router.push("/login");
                break;
            case 20009:
                if(language === "en"){
                    Message.warning("The receiving address does not match");
                }else{
                    Message.error("收货地址不符");
                }

                break;
            case 20100:
                if(language === "en"){
                    Message.warning("Invalid user name or password");
                }else{
                    Message.error("无效的用户名或密码");
                }

                break;
            case 20104:
                if(language === "en"){
                    Message.warning("Registration failed");
                }else{
                    Message.error("注册失败");
                }

                break;
            default:
                break;
        }
        return Promise.resolve(res.data);
    }

    // if (res.data.meta.status == 10000) {
    //     return res.data
    // } else {

    //     Promise.reject(res);

    //     Notification.error({
    //         title: "错误",
    //         message: res.data.meta.status + res.data.data,
    //     })
    // }

}, err => {
    return Promise.reject(err);
})

export default http



// WEBPACK FOOTER //
// ./src/http/request.js